module.exports = __webpack_public_path__ + "img/EPBusinessBack2.67f631fb.png";